export enum Service {
  Brands = 'ClientManagement:Brands',
  Groups = 'ClientManagement:Groups',
  Sites = 'ClientManagement:Sites',
}
